export default from './ChatPage';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatPage/index.js